import {
    clampNumberAttribute,
    parseEnumAttribute,
    parseTextAttribute,
} from "../shared/blockAttributes";

export type WritingAreaStyle = "blank" | "ruled" | "boxed";

export const WRITING_AREA_STYLES: readonly WritingAreaStyle[] = ["blank", "ruled", "boxed"];

export const MIN_WRITING_AREA_HEIGHT_MM = 15;
export const MAX_WRITING_AREA_HEIGHT_MM = 120;
export const DEFAULT_WRITING_AREA_HEIGHT_MM = 35;
export const DEFAULT_WRITING_AREA_LABEL = "Notes";

export interface PrintoutWritingAreaAttrs {
    heightMm: number;
    label: string;
    style: WritingAreaStyle;
}

export const clampWritingAreaHeightMm = (
    value: unknown,
    fallback = DEFAULT_WRITING_AREA_HEIGHT_MM,
): number => clampNumberAttribute(value, fallback, {
    integer: true,
    max: MAX_WRITING_AREA_HEIGHT_MM,
    min: MIN_WRITING_AREA_HEIGHT_MM,
});

export const DEFAULT_WRITING_AREA_ATTRS: PrintoutWritingAreaAttrs = {
    heightMm: DEFAULT_WRITING_AREA_HEIGHT_MM,
    label: DEFAULT_WRITING_AREA_LABEL,
    style: "ruled",
};

export const getWritingAreaAttrs = (
    attrs?: Partial<PrintoutWritingAreaAttrs> | null,
): PrintoutWritingAreaAttrs => ({
    heightMm: clampWritingAreaHeightMm(attrs?.heightMm),
    label: parseTextAttribute(attrs?.label, DEFAULT_WRITING_AREA_LABEL),
    style: parseEnumAttribute(attrs?.style, WRITING_AREA_STYLES, "ruled"),
});
